import React from "react";
import Textfield from "Components/UI/Form/Textfield";

//MUI
import Grid from "@mui/material/Grid";

import dayjs from "dayjs";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { systemStatusOptions } from "utils/options/systemStatusOptions";

export default function ClientArticleFormSystem({
  formData,
  handleInputChange,
}) {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Textfield
            disabled="true"
            label="KontrollStatus"
            value={formData.ParseStatus}
            type="number"
            onChange={(e) => handleInputChange("ParseStatus", e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Textfield
            disabled="true"
            label="KontrollMeddelande"
            value={formData.ParseMessage}
            onChange={(e) => handleInputChange("ParseMessage", e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <FormControl margin="dense" fullWidth sx={{ textAlign: "left" }}>
            <InputLabel>Status</InputLabel>
            <Select
              name="SystemStatus"
              value={formData.SystemStatus}
              onChange={(e) =>
                handleInputChange("SystemStatus", e.target.value)
              }
              label="SystemStatus"
              size="small"
            >
              {systemStatusOptions.map((options) => (
                <MenuItem key={options.Value} value={options.Value}>
                  {options.Name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Textfield
            disabled
            name="Skapad"
            label="Skapad"
            format="YYYY-MM-DD"
            slotProps={{
              textField: { size: "small", fullWidth: true, margin: "dense" },
            }}
            value={formData.CreateTime}
          />
        </Grid>
      </Grid>
    </>
  );
}
